import { Alert, Box, Button, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import { Login, LoginForm } from 'react-admin';
import { clearHubSignInError, peekHubSignInError, startHubSignIn } from '../../services/hubAuth';

const START_ERROR = 'Could not start sign-in with Enara Hub. Please try again.';

export const HubLoginPage = () => {
  const [error, setError] = useState<string | null>(peekHubSignInError);
  const [redirecting, setRedirecting] = useState(false);

  // Cleared after commit: StrictMode runs the state initializer twice
  useEffect(() => {
    clearHubSignInError();
  }, []);

  // Coming back from the Hub restores this page from the bfcache with the button disabled
  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) setRedirecting(false);
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  const handleHubSignIn = async () => {
    setError(null);
    setRedirecting(true);
    try {
      await startHubSignIn();
    } catch (e) {
      setRedirecting(false);
      setError(START_ERROR);
    }
  };

  // Above the form, and no focus change on mousedown: a focused field blurring
  // re-validates the form, the layout shifts and the first click misses the button.
  return (
    <Login>
      <Box px={2} pt={2}>
        {error && (
          <Alert severity='error' sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Button
          fullWidth
          variant='outlined'
          disabled={redirecting}
          onMouseDown={(e) => e.preventDefault()}
          onClick={handleHubSignIn}
        >
          Sign in with Enara Hub
        </Button>
        <Divider sx={{ mt: 2 }}>or</Divider>
      </Box>
      <LoginForm />
    </Login>
  );
};
